module.exports = __webpack_public_path__ + "static/media/elipse.eb241da8.png";